import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";
import axios from "axios";
import RealisationCard from "@/components/RealisationCard";

const API = process.env.REACT_APP_BACKEND_URL;

const fetchItems = (serviceType, city) => {
  const params = new URLSearchParams();
  if (serviceType) params.set("service_type", serviceType);
  if (city) params.set("city", city);
  return axios.get(`${API}/api/property/realisations?${params}`).then(({ data }) => data);
};

const RealisationsSection = ({ serviceType, city, title = "Nos réalisations" }) => {
  const [items, setItems] = useState([]);
  const [isLocal, setIsLocal] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        let data = city ? await fetchItems(serviceType, city) : [];
        setIsLocal(data.length > 0);
        if (data.length === 0) data = await fetchItems(serviceType);
        setItems(data.slice(0, 6));
      } catch { /* silent */ }
    })();
  }, [serviceType, city]);

  if (items.length === 0) return null;

  return (
    <section className="bg-white py-16 sm:py-20" data-testid="realisations-section">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-10">
          <p className="text-xs tracking-[0.2em] uppercase text-[#1A1A1A]/50 mb-2">Avant / Après</p>
          <h2 className="font-heading text-xl sm:text-2xl text-[#1A1A1A]" data-testid="realisations-title">
            {isLocal ? `Nos réalisations à ${city}` : title}
          </h2>
        </div>
        <div className={items.length === 1 ? "max-w-2xl mx-auto" : "grid sm:grid-cols-2 lg:grid-cols-3 gap-6"}>
          {items.map((item, i) => (
            <motion.div key={item.id} initial={{ opacity: 0, y: 15 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: i * 0.08 }}>
              <RealisationCard item={item} />
            </motion.div>
          ))}
        </div>
        <div className="text-center mt-8">
          <Link to="/property-services/realisations" data-testid="realisations-see-all"
            className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.15em] text-[#1A1A1A] border-b border-[#1A1A1A]/30 pb-1 hover:border-[#1A1A1A] transition-colors">
            Toutes nos réalisations par ville <ArrowRight size={12} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RealisationsSection;
